import { saveAs } from 'file-saver';
import { push } from "connected-react-router";
import { LinkStuff } from '../interface/MyInterfaces';

//import from helper functions
import { isAgg } from "./../components/Common/Helpers";

//import from auth-header.tsx
import { authHeader } from "../javascript/auth-header";

// import from user actions/action creators
import {
    authenticateUserOutsideLogin, thingsForSharedLink,
    changeReportVintage,
    loadInitialValuesForDistrictDetailedReport,
    addTriggeredEvent
} from "./UserActions"

// Action types for Detailed District Report
export const DetailedDistrictReportActionTypes = {
    LOAD_DETAILED_DISTRICT_REPORT_CONFIG: 'LOAD_DETAILED_DISTRICT_REPORT_CONFIG',
    LOAD_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS: 'LOAD_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS',
    CLEAR_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS: 'CLEAR_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS',
    LOAD_ALL_SPENDING: 'LOAD_ALL_SPENDING',
    CLEAR_ALL_SPENDING: 'CLEAR_ALL_SPENDING',
    DOWNLOAD_DETAILED_DISTRICT_REPORT_RESET: 'DOWNLOAD_DETAILED_DISTRICT_REPORT_RESET',
    DOWNLOAD_DETAILED_DISTRICT_REPORT_STARTED: 'DOWNLOAD_DETAILED_DISTRICT_REPORT_STARTED',
    DOWNLOAD_DETAILED_DISTRICT_REPORT_SUCCESS: 'DOWNLOAD_DETAILED_DISTRICT_REPORT_SUCCESS',
    DOWNLOAD_DETAILED_DISTRICT_REPORT_FAILURE: 'DOWNLOAD_DETAILED_DISTRICT_REPORT_FAILURE',
    SET_SELECTED_DISTRICT_ID: 'SET_SELECTED_DISTRICT_ID',
    CLEAR_SELECTED_DISTRICT_ID: 'CLEAR_SELECTED_DISTRICT_ID',
    SHARED_LINK_ACTIVE: 'SHARED_LINK_ACTIVE',
    SET_AGGREGATE_DISPLAY_ID: 'SET_AGGREGATE_DISPLAY_ID'
}

const loadDetailedDistrictReportConfig = (reportConfig) => ({
    type: DetailedDistrictReportActionTypes.LOAD_DETAILED_DISTRICT_REPORT_CONFIG,
    payload: reportConfig
})

// Action creator: loads top bullet points data for specified congressional district
export const loadDetailedDistrictReportTopBulletPoints = (congressTopBulletPointsData) => ({
    type: DetailedDistrictReportActionTypes.LOAD_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS,
    payload: congressTopBulletPointsData
});

// Action creator: clear top bullet points data for specified congressional district
export const clearDetailedDistrictReportTopBulletPoints = () => ({
    type: DetailedDistrictReportActionTypes.CLEAR_DETAILED_DISTRICT_REPORT_TOP_BULLETPOINTS,
    payload: {}
});

export const downloadDetailedDistrictReportReset = () => ({
    type: DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_RESET,
    payload: false
});

// Action creator: report downlaod started
export const downloadDetailedDistrictReportStarted = (downloadStarted) => ({
    type: DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_STARTED,
    payload: downloadStarted
});

// Action creator: successful report downlaod
export const downloadDetailedDistrictReportSuccess = (status) => ({
    type: DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_SUCCESS,
    payload: status
});

// Action creator: failed report downlaod
export const downloadDetailedDistrictReportFailure = (status) => ({
    type: DetailedDistrictReportActionTypes.DOWNLOAD_DETAILED_DISTRICT_REPORT_FAILURE,
    payload: status
});

// Action creator: set congressional district id
export const setSelectedDistrictId = (congressId) => ({
    type: DetailedDistrictReportActionTypes.SET_SELECTED_DISTRICT_ID,
    payload: congressId
});

// Action creator: clear congressional district id
export const clearSelectedDistrictId = () => ({
    type: DetailedDistrictReportActionTypes.CLEAR_SELECTED_DISTRICT_ID
});

// Action creator: toggle shared link indicator
export const setSharedLinkStatus = status => ({
    type: DetailedDistrictReportActionTypes.SHARED_LINK_ACTIVE,
    payload: status
});

// Action creator: set aggregate display id
export const setAggregateDisplayId = displayId => ({
    type: DetailedDistrictReportActionTypes.SET_AGGREGATE_DISPLAY_ID,
    payload: displayId
});

// Action creator: clear all spending data
export const clearAllSpending = () => ({
    type: 'CLEAR_ALL_SPENDING'
});


/**
 * API call to download the Congressional District Detailed Report for each state
 * first display id is for the report, second disply id is for the user
 * @param congressId - congressional district id
 * @param stateName - state name
 * @param vintage - report vintage
 * @param displayId - report display id
 * @param username
 * @param display_id - user's member university display id
 */

export const downloadDetailedDistrictReport = (congressId, stateName, vintage, displayId, username, display_id, report_university_name, min_year, max_year, release_date?) => {
    return async dispatch => {
        dispatch(downloadDetailedDistrictReportStarted(true));

        let url = "/IRISReportsMicroservice/api/PDF/CongressionalDistrictDetailSheetPDF/generate_pdf";

        let congressionalDistrictData = {};

        let now: Date = new Date();
        var currentDate = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();

        congressionalDistrictData["state_id"] = congressId.substring(0,2);
        congressionalDistrictData["cd_id"] = congressId;
        congressionalDistrictData["currentDateTime"] = currentDate;
        congressionalDistrictData["display_id"] = displayId;
        congressionalDistrictData["vintage"] = vintage;
        congressionalDistrictData["stateName"] = stateName;
        congressionalDistrictData["university"] = report_university_name;
        congressionalDistrictData["min_year"] = min_year;
        congressionalDistrictData["max_year"] = max_year;
        congressionalDistrictData["release_date"] = release_date;
        
        var headers = authHeader();
        headers.append('Content-Type', 'application/json'); // This one sends body

        fetch(url, { method: 'POST', body: JSON.stringify(congressionalDistrictData), headers })
            .then(res => {
                return res.blob();
            })
            .then(blob => {
                //saveAs(blob, 'IRIS_Congressional_District_Report_' + stateName + '_' + congressId.substring(2, 4) + currentDateTime + '.pdf');
                saveAs(blob, 'IRIS_Congressional_District_Report_' + currentDate + '.pdf'); //Amy wants the names to be consistent between the 3 govt reports
                dispatch(downloadDetailedDistrictReportSuccess("successful downlaod"));

                // log successful PDF download in database
                dispatch(addTriggeredEvent("Congressional District Detail Report", username, display_id, `downloaded ${isAgg(displayId) ? 'Aggregate' : 'User\'s University'} PDF Report for ${stateName}'s ${congressId.substring(2, 4)} congressional district`));

            }).catch((error) => {
                dispatch(downloadDetailedDistrictReportFailure(error.message));
            })
    }
}

// API call to get all spending data
export const getAllSpending = (displayId, vintage) => {
    return async dispatch => {

        var headers = authHeader();
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');

        let url = `/IRISReportsMicroservice/api/CongressionalDistrictDetailedReport/all-spending/${displayId}/${vintage}`;

        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                let allSpending = json

                dispatch({
                    type: DetailedDistrictReportActionTypes.LOAD_ALL_SPENDING,
                    payload: allSpending
                });
            })
        .catch(error => console.log(error.message))
    }
}

export const getDetailedDistrictReportConfig = (displayId, vintage) => {
    return async dispatch => {
        let url = `/IRISReportsMicroservice/api/CongressionalDistrictDetailedReport/report-config/${displayId}/${vintage}`;

        var headers = authHeader();
       
        await fetch(url, { method: 'GET', headers })
            .then((response) => {
                let reportConfig = response.json()
                reportConfig.then(data => {
                    // if success:
                    dispatch(loadDetailedDistrictReportConfig(data))

                })
            })
            .catch(error => console.log('api error', error))
    }
}

// API call to get Top Bullet Points
export const getDetailedDistrictReportDisplayData = (displayId, congressId, vintage) => {

    return async dispatch => {

        let url = `/IRISReportsMicroservice/api/CongressionalDistrictDetailedReport/top-bullet-points/${displayId}/${congressId}/${vintage}`;
        
        // make call to API to get top bullet points
        var headers = authHeader();
        
        fetch(url, { method: 'GET', headers })
            .then((response) => {
                let topBulletPointsData = response.json()
                topBulletPointsData.then(data => {
                    // if success:
                    dispatch(loadDetailedDistrictReportTopBulletPoints(data[0]))

                })
            })
            .catch(error => console.log('api error', error))
    }
}

// load shared link info
export const loadSharedReportLink = (link_id, p1, p2) => {
    return async dispatch => {

        let url = `/IRISReportsMicroservice/api/SharedLink/report_link/${link_id}/${p1}/${p2}`;

        var headers = authHeader();
        
        await fetch(url, { method: "GET", headers })
            .then(response => response.json())
            .then(async json => {
                var done = await authenticateUserOutsideLogin();

                var link: LinkStuff = json;

                if (link.link_id == -1) {
                    dispatch({
                        type: "BAD_LINK",
                        payload: link
                    });
                    dispatch(push("/reports/bad_link"));
                }

                else {
                    dispatch(getDetailedDistrictReportConfig(link.display_id, link.vintage));

                    dispatch(loadInitialValuesForDistrictDetailedReport(link.display_id, link.university, link.vintage));
                }
                // activate shared link status
                dispatch(setSharedLinkStatus(true));
            })
            .catch(error => console.log('shared link error', error))
    }
}